var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCorrespondance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 24 24",
    fill: "#fff",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 19C20 19.5523 19.5523 20 19 20H5C4.44772 20 4 19.5523 4 19V11.2268L10.0069 16.5663C11.1436 17.5767 12.8564 17.5767 13.9931 16.5663L20 11.2268V19ZM4.56205 8.99999H19.438L12.6402 3.33519C12.2693 3.02615 11.7307 3.02615 11.3598 3.33519L4.56205 8.99999ZM6.7552 11L11.3356 15.0715C11.7145 15.4083 12.2855 15.4083 12.6644 15.0715L17.2448 11H6.7552ZM19 22C20.6569 22 22 20.6568 22 19V8.99999C22 8.70321 21.8682 8.42177 21.6402 8.23177L13.9206 1.79875C12.808 0.871631 11.192 0.871633 10.0794 1.79875L2.35982 8.23177C2.13182 8.42177 2 8.70321 2 8.99999V19C2 20.6568 3.34315 22 5 22H19Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCorrespondance);
export default __webpack_public_path__ + "static/media/correspondance.bf7ba7af3bd55f9b794ac01b59abd63c.svg";
export { ForwardRef as ReactComponent };